import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://tellus-staging-api.organicresponse.com',
  apiPath: '/api/v1',
  frontendUrl: 'https://tellus-staging.organicresponse.com',
  elmtPollingInterval: 300000,
  lmsUrl: 'https://lms-staging.organicresponse.com'
};
